import type { StorefrontEnvironment } from '../app/common/interfaces/environment.interface';

// Public storefront configuration only — never Admin API or server secrets.

/**
 * win / staging. Public values for the sandbox Medusa backend, matching the
 * foundation the seed created there.
 */
export const environment: StorefrontEnvironment = {
  storeApiUrl: 'https://api.mistbelle.win',
  publishableKey:
    'pk_e49ff038ef872151a27c0019618d042f39842466077f31c2e1c76745e10f187d',
  regionId: 'reg_01M6K69VJ7X4DSME0Q3GAN5KJT',
};
